import { createSelector } from "@ngrx/store";
import { selectMetaDataState } from "../reducers";

export const selectRelatedMembers = createSelector(selectMetaDataState, state => state.getRelatedMembers);
export const selectLinkRelatedMember = createSelector(selectMetaDataState, state => state.linkRelatedMember);
